import { apiFetch } from './client';
import type { User } from '../types/mjai';

const TOKEN_KEY = 'nanikiru_token';

export function getStoredToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function setStoredToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function removeStoredToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export async function getMe(): Promise<User> {
  return apiFetch<User>('/auth/me');
}

export async function getAuthorizationUrl(returnUrl?: string): Promise<{ authorization_url: string; state: string }> {
  return apiFetch('/auth/x/authorize', {
    method: 'POST',
    body: JSON.stringify({ return_url: returnUrl ?? '/' }),
  });
}

export async function exchangeCode(code: string): Promise<{ access_token: string }> {
  return apiFetch('/auth/exchange', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });
}

export async function logout(): Promise<void> {
  await apiFetch('/auth/logout', { method: 'POST' });
  removeStoredToken();
}
